<template>
    
  <div>
    <!--<h2>History</h2> -->
    <div class="cc-history" style="height:100%">
      <cc-history-item
        v-for="history in filteredHistoryCalls"
        class="panel cc-panel-default"
        :class="{ active: isHistoryFromUserCaller(history) }"
        :history="history"
        @update="onUpdate"
        >
     </cc-history-item>
<!--
         <div class="panel cc-panel-default"  v-for="(history, index) in filteredHistoryCalls">

       
           
           <div class="media" >
            <div class="media-left media-middle">
              <a href="javascript://" tabindex="0" class="" style="color:black; display: inline;" role="button" data-toggle="popover" data-trigger="hover click" data-placement="left" 
                :title="tooltipTitle(index)" 
                :data-content="tooltipContent(index)"
              >
              <i class="fa fa-lg" aria-hidden="true"
               :class="[completionSymbol(history.completion)]" 
              ></i>
              </a>
            </div>
                       
            <div class="media-body">
              <div>
              <strong>{{getDateTime(history.datetimeBegin)}}</strong>
                - {{history.userCallerName}} für {{history.userClientName}}, {{history.companyClientName}}({{history.calledNumber}})
              </div>
              <div class="cc-msg">
                <small v-show="!history.message"><i>- kein Nachricht hinterlegt -</i></small>
                <small>{{history.message}}</small>
              </div>
            </div>
            
            <div class="media-right text-right media-middle">
              <button type="button"
                      title="Eintrag bearbeiten"
                      class="btn  btn-link cc-btn-menue"
                      v-on:click="editModus = true">
                      <span class="glyphicon glyphicon-option-vertical"></span>
              </button>
            </div>
        </div>
     </div>
 -->         
     <div v-show="!historyCalls.length" class="alert alert-warning" role="alert">Keine Calls in der History gefunden</div>

  </div>
</div>
                   
    
</template>



<script>

import bus from './common/bus'
import moment from 'moment'  
import * as KomboxConf from './common/kombox.conf'
import HistoryItem from './HistoryItem.vue'
  


export default {
    
  components: {
      'cc-history-item': HistoryItem,
  },
  
  data () {
    return {
      KomboxConf: KomboxConf,
      editModus: false,
      
      filter: {
          send: false,
          trash: false,
          abort: false,
          parking: false,
          userCaller: false,
      },

      historyCalls: [],
      limit: 50,
    }
  },
  
  created: function () {
    
    bus.registerOnIdCompanyClient(this.onIdCompanyClient);
    bus.registerOnIdUserClient(this.onIdUserClient);
    bus.registerOnUserCaller(this.onUserCaller);
    bus.registerOnResetUserCaller(this.onResetUserCaller);
  },

  mounted: function () {
    // Nach F5 holen wir uns die History Daten
    if(bus.isLoggedIn()){
      this.loadByUserCallCenter(bus.call.idUserCallCenter);
    }
  },
 

  
  computed: {
    
    filteredHistoryCalls: function () {
      
      return this.historyCalls
        .filter(item => !(item.completion.match("^Abschluss") && this.filter.send) )
        .filter(item => !(item.completion.match("^Papierkorb") && this.filter.trash) )
        .filter(item => !(item.completion.match("^Abbruch") && this.filter.abort) )
        .filter(item => !(item.completion.match("^Parking") && this.filter.parking) )
    },

    
    
  },
  
  methods: {

    isHistoryFromUserCaller: function (history) {
      return !!(bus.call.idUserCaller == history.idUserCaller && history.idUserCaller > 0)
    },
    
    
    onClickEdit: function () {
      this.editModus = 'edit';
    },

    onUpdate: function (history) {
      // ToDo Update 
      
    },

    close: function () {
      alert('');
    },
    
    completionSymbol: function (completion) {
      
      if (completion.match("^Abschluss")) {
          return 'fa-send'
      }
      
      if (completion.match("^Papierkorb")) {
        return 'fa-trash'
      }
      
      if (completion.match("^Abbruch")) {
        return 'fa-times-circle'
      }
      
      if (completion.match("^Parking")) {
        return 'fa-thumb-tack'
      }
    
    },
    
    tooltipTitle: function (index) {
      let historyCall = this.historyCalls[index]
      
      let ret = '';
      
      ret += historyCall.completion + ': '
      ret += this.getDateTime(historyCall.datetimeBegin) + ' - '
      ret += 'Agent: ' + historyCall.userCallCenterName
      ret +='<a style="position: absolute; right: 0; top: 0; text-align: right" class="btn btn-link" onclick="' + "$(this).parent().parent().popover('hide')" + '"><i class="fa fa-times" aria-hidden="true"></i></a>'
      return ret
    },

    tooltipContent: function (index) {
      let historyCall = this.historyCalls[index]
      
      let ret = '';
      
      ret += '<i>' + historyCall.userCallerName + ' für ' + historyCall.userClientName + ', ' + historyCall.companyClientName + '(' + historyCall.calledNumber + ')' + '</i>'
      
      ret += '<h3>Nachricht:</h3>'
      ret += historyCall.message || '<i>keine Nachricht hinterlassen!</i>'
      
      ret += '<h3>Kontakt:</h3>'
      let kontakt = ''
      historyCall.KomboxesUserCaller.map(
        item => kontakt += this.KomboxConf.TYPES[item.type].OPTION.TEXT + ': ' + item.content + ' - ' + item.description + '<br>'
      ) 
      ret += kontakt || '<i><b>Keine Kontaktdaten hinterlegt!</b></i>'
        
      ret += '<h3>Versand an:</h3>'
      let versand = ''
      historyCall.callShipments.map(
        item => versand += this.KomboxConf.TYPES[item.kombox.type].OPTION.TEXT + ': ' + item.kombox.content + ' - ' + item.kombox.description + '<br>'
      )
      ret += versand || '<i><b>Keine Veranad aktiviert!</b></i>'
      
      
      return ret
    },


    getDateTime: function (dateTime) {
      moment.locale('de');
      let d = new Date(dateTime);
      let d_now = new Date();
      let dateString = '';
      
      
      if(d.toDateString() == d_now.toDateString()){
        dateString = 'Heute, ' + moment(d).format('HH:mm');
      }else{
        dateString = moment(d).format('dd DD.MM, HH:mm');
      }
        
      
      return dateString;
    },

    

    onLogin: function (loginData, event, call) {
      console.log('History:onLogin');
      this.reset();
      this.loadByUserCallCenter(loginData.userCallCenter.idCallUserCallCenter);
    },
    
    
    onIdCompanyClient: function (idCompanyClient, event, call) {
      this.reset();
      if(idCompanyClient != 0){
        this.loadByCompanyClient(idCompanyClient);
      }else{
        // wenn 0 dann die calls vom Agenten anzeigen
        this.loadByUserCallCenter(call.idUserCallCenter);
      }
    },

    onIdUserClient: function (idUserClient, event, call) {
      //this.reset();
    },

    onUserCaller: function (userCaller, event, call) {
      this.reset();
      if(userCaller.idCompany != 0){
        // wenn es eine Firma gibt so zeigen wir die History
        this.loadByCompanyCaller(bus.call.idCompanyClient,userCaller.idCompany);
      }else{
        this.loadByUserCaller(bus.call.idCompanyClient,userCaller.id);
      }
    },

    onResetUserCaller: function (userCaller, event, call) {
      this.reset();
      if(call.idCompanyClient != 0){
        this.loadByCompanyClient(call.idCompanyClient);
      }else{
        // wenn 0 dann die calls vom Agenten anzeigen
        this.loadByUserCallCenter(call.idUserCallCenter);
      }
        
    },

    reset: function () {
      this.historyCalls = [];
    },
    

    // Wenn kein Auftraggeber ausgewählt, dann werden die letzten calls des Agenten gezeigt
    loadByUserCallCenter: function (idUserCallCenter) {
      const query = 'user/callcenter/' + idUserCallCenter;
      const options = {params: {limit: this.limit}};
      this.load(query,options);
    },

    // Wenn ein Auftraggeber aber kein Anrufer ausgewählt, dann werden die letzten calls des Auftraggeber gezeigt
    loadByCompanyClient: function (idCompanyClient) {
      const query = 'company/client/' + idCompanyClient;
      const options = {params: {limit: this.limit}};
      this.load(query,options);
    },

    // Wenn ein Auftraggeber und ein Anrufer ausgewählt, dann werden die letzten calls des Anrufers gezeigt
    loadByUserCaller: function (idCompanyClient, idUserCaller) {
      const query = 'company/client/' + idCompanyClient;
      const options = {params: {idUserCaller: idUserCaller, limit: this.limit}};
      this.load(query,options);
    },

    // Wenn ein Auftraggeber und ein Anrufer ausgewählt, dann werden die letzten calls des Anrufers gezeigt
    loadByCompanyCaller: function (idCompanyClient, idCompanyCaller) {
      const query = 'company/client/' + idCompanyClient;
      const options = {params: {idCompanyCaller: idCompanyCaller, limit: this.limit}};
      this.load(query,options);
    },
    

    load: function (query,options ) {
      this.$http.get(bus.config.path + '/history/' + query, options).then((response) => {
        this.historyCalls = response.data;
        
        this.$nextTick(function () {
          $("[data-toggle=popover]").popover( {html: true,  container: 'body'} );
       })

        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },

    
  }
  
}
</script>

<style>

  .popover{
     width: 30%;
     max-width: 100% !important;
     box-shadow: 0px 0px 20px #333;  
     /*background-color: #fcf8e3;*/
  }

  .popover-title{
    font-weight: bold;
  }

</style>


  <style scoped>

  .active{
     background-color: #fcf8e3;
  } 
    
  .cc-panel-default:hover{
     background-color: #fcf8e3;
  }
  
  .cc-msg{
    overflow: hidden;
    white-space: nowrap;
    margin-right: 10px
  }  
  
h2 .fa, .panel .fa {
    padding-right: 2px;
}
  
    .fa-send{
      color: #449d44;      
    }
    
    .fa-trash{
      color: #f0ad4e;       
    }
    .fa-times-circle{
      color: #d9534f;
    }
    
    .fa-thumb-tack{
      color: #337ab7;       
    }
  
  small{
    color: gray;
  }  
  
.panel {
    margin-bottom: 4px;
    border-bottom: 1px solid lightgrey;
}

.panel-title{
  font-size: 14px  ;
}

.cc-history{
    overflow: auto;
  }

</style>



// WEBPACK FOOTER //
// History.vue?badff3a4